export default __webpack_public_path__ + "static/media/ilustration.f7f9b98c.svg";